export const MAX_FILE_BYTES = 20 * 1024 * 1024;
export const MAX_FILE_LABEL = "less than 20MB";
export const FILE_CHUNK_BYTES = 4 * 1024 * 1024;

export const RETENTION_OPTIONS = {
  "5min": 5 * 60 * 1000,
  "1hr": 60 * 60 * 1000,
  "4hr": 4 * 60 * 60 * 1000,
  "24hr": 24 * 60 * 60 * 1000,
  forever: null
} as const;

export type Retention = keyof typeof RETENTION_OPTIONS;
export const DEFAULT_RETENTION: Retention = "24hr";
